import styled from 'styled-components';
export const ModalWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,0.5);
    z-index: 1000;
`;

export const Modal = styled.div`
    position:absolute;
    bottom: 0;
    background : white;
    width : 100%;
    background: #FFFFFF;
    border-top-left-radius: calc(100vw * (16 / 375));
    border-top-right-radius: calc(100vw * (16 / 375));
`;
export const ModalHeader = styled.div`
    position :relative;
    display: flex;
    justify-content: space-between;
    margin-bottom: calc(100vw * (20 / 375));
    padding : 0 calc(100vw * (17 / 375));
    align-items: center;
`;
export const HeaderLeft = styled.div``;
export const HeaderMid = styled.div`
    margin-top : calc(100vw * (-25 / 375));
    width:calc(100vw * (63 / 375));
    height:calc(100vw * (63 / 375));
`;
export const AppIcon = styled.img``;
export const HeaderRight = styled.div`
    display: inline-block;
    width:calc(100vw * (14 / 375));
    height:calc(100vw * (14 / 375));
`;
export const CloseIcon = styled.img`
    width : 100%;
    height: 100%;
    object-fit: cover;
`;
export const ModalBody = styled.div`
    padding : 0 calc(100vw * (20 / 375)) calc(100vw * (30 / 375));
`;
export const ModalTxt = styled.div`
    font-weight: bold;
    font-size: calc(100vw * (18 / 375));
    line-height: calc(100vw * (26 / 375));
    text-align: center;
    color: #121212;
    margin-bottom : calc(100vw * (20 / 375));
`;

export const AppStoreBtn = styled.a`
    display: inline-block;
    background: #FFCF19;
    border-radius: calc(100vw * (5 / 375));
    width : 100%;
    padding:  calc(100vw * (18 / 375)) 0;
    font-weight: bold;
    font-size: calc(100vw * (16 / 375));
    line-height: calc(100vw * (23 / 375));
    color: #4E4E4E;
    text-align: center;
`;
